import { Dropdown, DropdownOption } from '@hawkins/components';
import { lensSqueezeFactorLookup } from 'src/domains/api/static';

interface LensSqueezeInputProps {
  onChange: (newValue: DropdownOption<number> | null) => void;
  value: DropdownOption<number>;
}

export const LensSqueezeInput = ({
  onChange,
  value,
}: LensSqueezeInputProps) => {
  return (
    <Dropdown
      creatable
      searchable
      dropdownWidthType="full"
      label="Lens Squeeze Factor"
      options={lensSqueezeFactorLookup}
      value={value}
      onChange={(newValue) => {
        if (newValue?.value && !isNaN(newValue.value)) {
          onChange(newValue);
        }
      }}
      onCreateOption={(inputValue) => {
        const parsedValue = parseFloat(inputValue);
        if (!isNaN(parsedValue)) {
          const label =
            parsedValue === 1
              ? '1x (Spherical)'
              : `${parsedValue}x (Anamorphic)`;
          return {
            label,
            value: parsedValue,
          };
        }
      }}
    />
  );
};
